import {
  getCollectDatas,
  getAreaDatas,
  subCollectDatas
} from '@/services/config'
import rules from './rules'
export default {
  namespaced: true,
  state: {
    submitting: false,
    datasReady: false,
    form: '',
    childKeys: [],
    datas: [],
    areaDatas: [],
    areaDatasReady: false,
    treeDatas: [],
    isCofigFormEdit: false,
    isBtnDisable: false,
    decorators: {
      mobile12: ['mobile', { rules: rules.tel }],
      checkcode: ['checkcode', { rules: rules.validCode }],
      username: ['username', { rules: rules.username }],
      password: ['password', { rules: rules.password }],
      truename: ['truename', { rules: rules.truename }]
    },
    devDatas: {}
  },
  mutations: {
    // 设置数据容器的值
    setDatas (state, datas) {
      state.datas = datas
      state.datasReady = true
    },
    setSubmitting (state, type) {
      state.submitting = type
    },
    setForm (state, form) {
      state.form = form
    },
    setChildKeys (state, keys) {
      state.childKeys = keys
    },
    setAreaDatas (state, datas) {
      state.areaDatas = datas
      state.areaDatasReady = true
    },
    setTreeData (state, datas) {
      state.treeDatas = datas
    },
    setIsEdit (state, b) {
      state.isCofigFormEdit = b
    },
    setBtnDisable (state, b) {
      state.isBtnDisable = b
    },
    setDevDatas (state, data) {
      state.devDatas = data
    }
  },
  actions: {
    async fetchCollectDatas ({ commit }) {
      commit('setSubmitting', true)
      const chain = await getCollectDatas()
        .onSuccess((raw) => {
          commit('setDatas', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async fetchDevDatas ({ commit }, params = {}) {
      commit('setSubmitting', true)
      const chain = await getCollectDatas()
        .params(params)
        .onSuccess((raw) => {
          commit('setDevDatas', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    async fetchAreaDatas ({ commit }) {
      commit('setSubmitting', true)
      const chain = await getAreaDatas()
        .onSuccess((raw) => {
          commit('setAreaDatas', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async subCollect ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await subCollectDatas()
        .onSuccess(async () => {
          // const res = await dispatch('fetchCollectDatas', type)
          // res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    addClick () {
      window.onbeforeunload = function (e) {
        return false
      }
    },
    removeClick () {
      window.onbeforeunload = null
    }

  }
}
